import React from 'react';
import { MemberRole, RoleCategory } from '../types/types';

/* ── Color mapping by category ─────────────────────────────────────────── */

const categoryStyles: Record<RoleCategory, { bg: string; color: string; border: string }> = {
  government: { bg: '#E6F1FB', color: '#0C447C', border: '#B5D4F4' },
  knesset:    { bg: '#EAF3DE', color: '#27500A', border: '#B8D8A8' },
  opposition: { bg: '#FCEBEB', color: '#501313', border: '#F4B5B5' },
  committee:  { bg: '#f5f5f5', color: '#666',    border: '#e0e0e0' },
};

/* ── Component ──────────────────────────────────────────────────────────── */

interface RoleTagProps {
  role: MemberRole;
  size?: 'small' | 'normal';
}

const RoleTag = ({ role, size = 'normal' }: RoleTagProps) => {
  const style = categoryStyles[role.category] || categoryStyles.committee;
  const isSmall = size === 'small';

  // One line, cut with an ellipsis when wider than its container (long committee-chair
  // titles); the full title is in the tooltip
  return (
    <span title={role.title} style={{
      display: 'inline-block',
      maxWidth: '100%',
      boxSizing: 'border-box',
      verticalAlign: 'middle',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: isSmall ? '10px' : '11px',
      fontWeight: role.isPrimary ? 600 : 500,
      padding: isSmall ? '2px 6px' : '3px 9px',
      borderRadius: '6px',
      background: style.bg,
      color: style.color,
      border: `0.5px solid ${style.border}`,
    }}>
      {role.title}
    </span>
  );
};

export default RoleTag;
